<template>
    <span>
        <template v-if="currency">&euro;</template>
        <template v-if="price">
            <span v-html="formattedPrice"></span>
        </template>
        <template v-else>-</template>
    </span>
</template>


<script>
import { Vue, Options } from 'vue-class-component'
import PriceMode from '../enum/PriceMode';

import { createNumberFilter } from '@wittignl/js-core/src/js/filter/number'
import di from 'di';

export default Options({
    name: 'dmb-price',
    props: {
        currency: Boolean,
        mode: String,
        price: Number
    }
})(
    class Price extends Vue {
        get formattedPrice() {

            const numberFilterBind = { context: { i18n: di.get('i18n') } };

            switch (this.mode) {

                case PriceMode.DECIMAL_COMMA:

                    const filterComma = createNumberFilter('.', ',', 2).bind(numberFilterBind);
                    return filterComma(this.price, 2, 2);

                case PriceMode.DECIMAL_POINT:

                    const filterPoint = createNumberFilter(',', '.', 2).bind(numberFilterBind);
                    return filterPoint(this.price, 2, 2);

                case PriceMode.DECIMAL_DASH:

                    const filterWithComma = createNumberFilter('.', ',', 2).bind(numberFilterBind);                                    
                    const result = filterWithComma(this.price, 2, 2);

                    if (result.endsWith(',00')) {
                        return result.replace(',00', ',-');
                    }
                    else {
                        return result;
                    }

                case PriceMode.DECIMAL_NO:
                    return this.$f.number(this.price, 0, 0);

                case PriceMode.DECIMAL_SMALL:
                    const numberWithPoint = createNumberFilter(',', '.', 2).bind(numberFilterBind);
                    const numbers = ("" + numberWithPoint(this.price, 2, 2)).split(".", 2);

                    return numbers[0] + '<sup>' + numbers[1] + '</sup>';
            }
        }
    }
)

</script>